// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"191":"b9b5dc14","378":"b869a3bc","772":"194eea8f"}[chunkId] + ".chunk.css";
};